import React from 'react'

import { cn } from '@/lib'

export const Section = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement> & { ring?: boolean }>(
  ({ className, ring = true, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-black-100 dark:bg-white-4 rounded-sm px-4 md:px-6 py-3',
          ring && 'ring-[1px] md:ring-[0.5px] [@media(max-resolution:1.9dppx)]:ring-[1px] ring-white-10',
          className
        )}
        {...props}
      />
    )
  }
)
